import styled from "styled-components";

import { COLORS, FONT_SIZE, FONTS } from "../../../constants/Styles";
import { MAX_BODY_SIZE } from "../ReviewBoardFlowStyles";

export const QUOTE_TOOL_BACKGROUND_COLOR = COLORS.tableBackground;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  flex-grow: 1;
  max-width: ${MAX_BODY_SIZE};
`;

export const DemoBoard = styled.div`
  font-size: ${FONT_SIZE.size14};
  text-align: center;
  color: ${COLORS.secondaryLight};
`;

export const QuoteToolContainer = styled.div`
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  background: ${QUOTE_TOOL_BACKGROUND_COLOR};
  padding: 2rem;
  gap: 2rem;
`;

export const QuoteToolTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
`;
